import { NgModule } from '@angular/core';
import { RouterModule, Routes,Router } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import {OktaCallbackComponent, OktaAuthGuard, OktaAuthService} from '@okta/okta-angular';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PreferredPricingComponent } from './pages/preferred-pricing/preferred-pricing.component';
import { AccountComponent } from './pages/account/account.component';
import { ActiveQuoteComponent } from './pages/active-quote/active-quote.component';
import {RequestHistoryComponent} from "./pages/request-history/request-history.component";
import {NewQuoteRequestComponent} from "./pages/new-quote-request/new-quote-request.component";
import {MatrixRequestHistoryComponent} from "./pages/matrix-request-history/matrix-request-history.component";
import {PageNotFoundComponent} from "./components/page-not-found/page-not-found.component";
import {RouteResolverService} from "./services/route-resolver.service";
import {AdminComponent} from "./pages/admin/admin.component";
import {ContractTemplatesComponent} from "./pages/contract-templates/contract-templates.component";
import {DisableContractsComponent} from "./pages/disable-contracts/disable-contracts.component";
export function onAuthRequired(oktaAuth, injector) {
  const router = injector.get(Router);

  // Redirect the user to your custom login page
  router.navigate(['/login']);
}

// const userAccess = () => {
//   return UtilService.getUserType();
// }

const routes: Routes = [

  { path: '', pathMatch: 'full', redirectTo :'/dashboard', resolve: {routerResolve: RouteResolverService} },
  { path: 'login', component: LoginComponent },
  { path: 'custom-deals', component: ActiveQuoteComponent, canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}   },
  { path: 'price-history', component: MatrixRequestHistoryComponent, canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}   },
  { path: 'dashboard', component: DashboardComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}  },
  { path: 'quick-quotes', component: PreferredPricingComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
  }, resolve: {routerResolve: RouteResolverService}},
  { path: 'rfp-history', component: RequestHistoryComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}},
  { path: 'contract-history', component: RequestHistoryComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}},
  { path: 'contract-templates', component: ContractTemplatesComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}},
  { path: 'disable-contract-download', component: DisableContractsComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}},
  { path: 'new-request', component: NewQuoteRequestComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}},
  { path: 'new-request/:id', component: NewQuoteRequestComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}},
  { path: 'admin', component: AdminComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }, resolve: {routerResolve: RouteResolverService}},
  { path: 'account', component: AccountComponent,  canActivate: [ OktaAuthGuard ], data: {
      onAuthRequired
    }},
  { path: 'login/callback', component: OktaCallbackComponent  },
  {path: '404', component: PageNotFoundComponent},
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
